export const FETCH_DETAILS = 'emarketing/template/details';
export const FETCH_DETAILS_SUCCESS = 'emarketing/template/details_success';
export const FETCH_DETAILS_FAILED = 'emarketing/template/details_failed';

export const FETCH_LIST = 'emarketing/template/list';
export const FETCH_LIST_SUCCESS = 'emarketing/template/list_success';
export const FETCH_LIST_FAILED = 'emarketing/template/list_failed';

export const CREATE = 'emarketing/template/create';
export const CREATE_SUCCESS = 'emarketing/template/create_success';
export const CREATE_FAILED = 'emarketing/template/create_failed';

export const UPDATE = 'emarketing/template/update';
export const UPDATE_SUCCESS = 'emarketing/template/update_success';
export const UPDATE_FAILED = 'emarketing/template/update_failed';

export const DELETE = 'emarketing/template/detele';
export const DELETE_SUCCESS = 'emarketing/template/detele_success';
export const DELETE_FAILED = 'emarketing/template/detele_failed';

export const BULK = 'emarketing/template/bulk';
export const BULK_SUCCESS = 'emarketing/template/bulk_success';
export const BULK_FAILED = 'emarketing/template/bulk_failed';

export const CLEAR_DATA = 'emarketing/template/clear_data';

export type EmarketingTemplateAction =
  | typeof FETCH_DETAILS
  | typeof FETCH_DETAILS_FAILED
  | typeof FETCH_DETAILS_SUCCESS
  | typeof FETCH_LIST
  | typeof FETCH_LIST_FAILED
  | typeof FETCH_LIST_SUCCESS
  | typeof CREATE
  | typeof CREATE_FAILED
  | typeof CREATE_SUCCESS
  | typeof UPDATE
  | typeof UPDATE_FAILED
  | typeof UPDATE_SUCCESS
  | typeof DELETE
  | typeof DELETE_FAILED
  | typeof DELETE_SUCCESS
  | typeof BULK
  | typeof BULK_FAILED
  | typeof BULK_SUCCESS
  | typeof CLEAR_DATA;
